import { Container, Typography } from "@mui/material";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ArchitectureOutlinedIcon from "@mui/icons-material/ArchitectureOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import { useContext } from "react";
import { LocalizationContext, SelectedSkillContext } from "src/lib/context";
import { upperFirst } from "lodash";
import { ViewInArOutlined } from "@mui/icons-material";

interface ICombinedCategoriesIcons {
  text: string;
  skillId: string;
  icon: () => any;
}

const InspirationsCategories = () => {
  const { uiGeneral } = useContext(LocalizationContext).localeStrings;
  const { selectedSkills, setSelectedSkills } =
    useContext(SelectedSkillContext);

  const combineCategories = () => {
    const combined: ICombinedCategoriesIcons[] = [];
    uiGeneral.skills.forEach((skill, i) => {
      // let icon = () => <PendingOutlinedIcon color="disabled" />;
      let icon = () => <PanoramaFishEyeIcon color="disabled" />;
      switch (skill.skillId.toLowerCase()) {
        case "agricultural":
          icon = () => <AgricultureIcon color="disabled" />;
          break;
        case "creative":
          icon = () => <ColorLensOutlinedIcon color="disabled" />;
          break;
        case "survey and mapping":
          icon = () => <ArchitectureOutlinedIcon color="disabled" />;
          break;
        case "education":
          icon = () => <SchoolOutlinedIcon color="disabled" />;
          break;
        case "service":
          icon = () => <HandshakeOutlinedIcon color="disabled" />;
          break;
        case "fpv":
          icon = () => <ViewInArOutlined color="disabled" />;
          break;
      }

      combined.push({
        icon,
        text: skill.name,
        skillId: skill.skillId,
      });
    });

    combined.push({
      icon: () => <PendingOutlinedIcon color="disabled" />,
      text: upperFirst(uiGeneral.all),
      skillId: "-1",
    });

    return combined;
  };

  function handleSelect(text: string) {
    setSelectedSkills([]);
    if (text != "-1") {
      setSelectedSkills([text]);
    }
  }

  return (
    <Container className="inspire__categories">
      <h5 className="subtitle-1">Explore categories</h5>
      <div className="inspire__categories--items">
        {combineCategories().map((elem) => (
          <div
            className={`inspire__categories--item ${
              selectedSkills.some(
                (s) => s?.toLowerCase() === elem.skillId?.toLowerCase()
              )
                ? "inspire__categories--item-active"
                : ""
            }`}
            key={elem.text}
            onClick={() => handleSelect(elem.skillId)}
          >
            {elem.icon()}
            <Typography>{elem.text}</Typography>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default InspirationsCategories;
